<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .card {
    @include colors.background-color(interfaceSwGrey_10);
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);
    border-radius: utils.in_rem(6px);
    padding: utils.in_rem(24px);
    margin-top: utils.in_rem(30px);
    margin-bottom: utils.in_rem(20px);

    .header {
      @include mixins.h4();
      display: flex;
      align-items: center;
      gap: utils.in_rem(8px);
    }

    .priority {
      @include mixins.h4();

      .label {
        @include mixins.body2();
      }
    }

    .notes {
      @include colors.background-color(interfaceWhite);
      @include mixins.body2();
      padding: utils.in_rem(20px);
      border-radius: utils.in_rem(8px);
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { capitalizeFirstLetter } from "../../../../../assets/js/src/general/utils";
  import { todosModalItemStore } from "../stores";

  const config = {
    phoneCall: {
      icon: "far fa-phone",
      label: "Phone Call",
    },
    email: {
      icon: "far fa-envelope",
      label: "Email",
    },
    sendInmail: {
      icon: "fab fa-linkedin",
      label: "Send InMail",
    },
    linkedinConnectionRequest: {
      icon: "fab fa-linkedin",
      label: "Connection Request",
    },
    meeting: {
      icon: "far fa-calendar",
      label: "Meeting",
    },
    generalTask: {
      icon: "far fa-clipboard-check",
      label: "General Task",
    },
  };

  const { task, toDoType, priority, notes } = $derived($todosModalItemStore);

  const icon = $derived(config[toDoType]?.icon || "far fa-list-check");
  const title = $derived(
    config[toDoType]?.label
      ? `${config[toDoType].label} - ${capitalizeFirstLetter(task)}`
      : capitalizeFirstLetter(task)
  );
</script>

<div class="card">
  <div class="header">
    <Icon class="{icon} color-activityMessage_50" />
    {title}
  </div>
  <div class="priority">
    Priority:
    <span class="label">{capitalizeFirstLetter(priority)}</span>
  </div>
  {#if notes}
    <div class="notes">
      {notes}
    </div>
  {/if}
</div>
